export default __webpack_public_path__ + "static/media/img7.50d19601.jpg";